export interface CitationHighlight {
  citationId: string;
  leftPct: number;
  topPct: number;
  widthPct: number;
  heightPct: number;
}

export interface Size {
  width: number;
  height: number;
}

export interface ImageContentRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export const rotateHighlight = (highlight: CitationHighlight, degrees: number): CitationHighlight => {
  const { leftPct, topPct, widthPct, heightPct } = highlight;

  switch (degrees % 360) {
    case 90:
      return {
        ...highlight,
        leftPct: 100 - topPct - heightPct,
        topPct: leftPct,
        widthPct: heightPct,
        heightPct: widthPct,
      };
    case 180:
      return { ...highlight, leftPct: 100 - leftPct - widthPct, topPct: 100 - topPct - heightPct };
    case 270:
      return {
        ...highlight,
        leftPct: topPct,
        topPct: 100 - leftPct - widthPct,
        widthPct: heightPct,
        heightPct: widthPct,
      };
    default:
      return highlight;
  }
};

export const getContainedImageRect = (elementSize: Size, naturalSize: Size): ImageContentRect => {
  if (naturalSize.width <= 0 || naturalSize.height <= 0) {
    return { left: 0, top: 0, width: 0, height: 0 };
  }

  const scale = Math.min(elementSize.width / naturalSize.width, elementSize.height / naturalSize.height);
  const width = naturalSize.width * scale;
  const height = naturalSize.height * scale;

  return {
    left: (elementSize.width - width) / 2,
    top: (elementSize.height - height) / 2,
    width,
    height,
  };
};
